import Instance from './resource'
export default {
  // login
  login(data) {
    return Instance.post('login/login', data);
  },
  quickLogin(data) {
    return Instance.post('login/fastLogin', data)
  },
  // set password for new user
  setPasswordForNewUser(data) {
    return Instance.post('user/setPwd', data)
  },
  // logout
  logout(data) {
    return Instance.post('login/logout', data);
  },
  // check is siChuan mobile user
  checkIsSCMbl(data) {
    return Instance.post('account/checkScMbl', data);
  },
  // send verify code
  sendVerifyCode(data) {
    return Instance.post('account/getVerificationCode', data);
  },
  // forget password
  forgetPassword(data) {
    return Instance.post('user/forgetPwd', data);
  },
  // register
  register(data) {
    return Instance.post('user/register', data);
  },
  // check has registered
  checkHasRegistered(data) {
    return Instance.post('user/checkMblNoForLogin', data);
  },
  // fetch agreement url
  fetchAgreementUrl(data) {
    return Instance.post('system/getMsgInf', data);
  },
  // real name
  realName(data) {
    return Instance.post('account/certification', data);
  },
  // reset password
  resetPassword(data) {
    return Instance.post('user/editPwd', data);
  },
  // real name info
  fetchRealNameInfo(data) {
    return Instance.post('account/getCertificationInfo', data);
  },
  // check verify code
  checkVerifyCode(data) {
    return Instance.post('account/checkVerificationCode', data);
  },
  // check is login
  checkIsLogin(data) {
    return Instance.post('account/checkUserIsLogin', data);
  },
  // fetch invite list
  fetchInvitationList(data) {
    return Instance.post('user/getWheelInfo', data);
  },
  // add wheel time record
  addWheelTimeRecord(data) {
    return Instance.post('user/addWheelTimeRecord', data);
  },
  // fetch my loan list
  fetchMyLoanList(data) {
    return Instance.post('system/getNewMyLoanList', data);
  },
  // fetch zhaoLian loan list
  fetchZhaoLianLoanList(data) {
    return Instance.post('system/zlLoanHistory', data);
  },
  // 检测用户是否有新的贷款数据未查看
  checkNewestCreditGranting(data) {
    return Instance.post('system/newestCreditGranting', data)
  },
  // 获取微信Code
  getWeixinCode(data) {
    return Instance.get('wechat/queryOpenIdFindUserInfo', { params: data })
  },
  // 查询用户注销状态
  queryApplyState(data) {
    return Instance.post('logoutApply/query', { params: data })
  },
  // 申请注销账号
  applyLogoutAccount(data) {
    return Instance.post('logoutApply/save', { params: data })
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js